// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"1e5e967b","116":"c0eaef75","314":"89d60cdc","352":"6b1738af","799":"9c53ec1b"}[chunkId] + ".chunk.js";
};